/**Stitch types whose Bight field is shown and required under the GSD V4 calculation engine.*/
export const V4_BIGHT_STITCH_TYPE_CODES: readonly string[] = [
  "102",
  "107",
  "204",
  "206",
  "211",
  "213",
  "214",
  "215",
  "219",
  "220",
  "302",
  "303",
  "304",
  "305",
  "306",
  "307",
  "308",
  "309",
  "310",
  "311",
  "312",
  "313",
  "314",
  "315",
  "316",
  "320",
  "321",
  "322",
  "323",
  "324",
  "325",
  "326",
  "327",
  "328",
  "329",
  "402",
  "403",
  "404",
  "405",
  "406",
  "407",
  "408",
  "409",
  "410",
  "411",
  "412",
  "413",
  "414",
  "415",
  "416",
  "417",
  "501",
  "502",
  "503",
  "504",
  "505",
  "506",
  "507",
  "508",
  "509",
  "510",
  "511",
  "512",
  "513",
  "514",
  "515",
  "516",
  "521",
  "522",
  "601",
  "602",
  "603",
  "604",
  "605",
  "606",
  "607",
  "608",
  "609"
];

/**Default Bight in mm for a new operation, used only when the stitch type has no default of its own.*/
export const V4_DEFAULT_BIGHT_IN_MM = 3;

/**Largest Bight accepted, in mm. The server checks the same limit in V4OperationHelper.EnsureValidBight.*/
export const V4_MAX_BIGHT_IN_MM = 999;

/** Returns true when the given stitch type needs a Bight under GSD V4. */
export function gsdV4StitchTypeNeedsBight(stitchTypeCode?: string | null): boolean {
  if (!stitchTypeCode) {
    return false;
  }
  // The edit form may carry the code with a "-description" suffix; compare on the base code only.
  const baseCode = stitchTypeCode.split("-")[0].trim();
  return V4_BIGHT_STITCH_TYPE_CODES.includes(baseCode);
}
